// Copyright (c) Bentley Systems
import { Parameter } from "./parameter";

export class DbCall {
  public targetNodeType: string | undefined;
  public targetNodeId: number | undefined;
  public parameters: Parameter[] = [];

  constructor(initializer?: any) {
    if (!initializer) {return;}
    if (initializer.targetNodeType)
      {this.targetNodeType = initializer.targetNodeType;}
    if (initializer.targetNodeId) {this.targetNodeId = initializer.targetNodeId;}
  }
}
